<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="moraghebat-font" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/contents\/2NbiMfVloaOtdWP3WjfqS2dC5Mbhk95mPlWgsWGK.png","alt":"arair"},...{}}' :style='"height:300px;\nobject-fit:contain;"' class="col-12  text-center" ></m-img><m-h4 v-bind='{...{},...{}}' :style='""' class="col \nmb-4" >
                <template #default>مراقبت‌های بعد از لیزر موهای زائد   </template>
                </m-h4></template>
                </m-div></template>
                </m-div><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/contents\/03 (1).jpg","alt":"arair"},...{}}' :style='"height:1000px;\nobject-fit:contain;"' class="col-12  text-center " ></m-img><m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>نکاتی در مورد مراقبت‌های بعد از لیزر مو های زائد
   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="text-center m-5 " >
                <template #default>رعایت مراقبت‌های بعد از لیزر، باعث کاهش التهاب پوست و افزایش اثربخشی درمان می‌شود.   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>خنک کردن پوست   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>بعد از لیزر ممکن است قرمزی یا سوزش خفیف احساس کنید. برای آرام کردن پوست از کمپرس سرد یا ژل آلوئه‌ورا خنک استفاده کنید. در صورت تحریک، کرم‌های ترمیم‌کننده مانند بپانتن پلاس یا سیکالفیت بسیار مؤثرند.   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px;\nfont-size:30px;"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>پرهیز از گرما و تعریق زیاد   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>تا ۴۸ ساعت بعد از لیزر از موارد زیر خودداری کنید:

حمام داغ، سونا یا جکوزی،

ورزش‌های سنگین یا تعریق زیاد،

ماساژ روی ناحیه لیزرشده.
گرما می‌تواند باعث التهاب یا تحریک پوست شود.
   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px;\nfont-size:30px;"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>اجتناب از آفتاب   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>پوست پس از لیزر حساس‌تر است. تا دو هفته در معرض آفتاب مستقیم یا سولاریوم قرار نگیرید. هنگام خروج از منزل حتماً از کرم ضدآفتاب SPF ۳۰ یا بالاتر استفاده کنید.
   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px;\nfont-size:30px;"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>مراقبت از پوست ناحیه لیزرشده   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>تا ۴۸ ساعت بعد از لیزر از استفاده از عطر، دئودورانت، کرم‌های معطر یا محصولات لایه‌بردار خودداری کنید. لباس‌های نخی و آزاد بپوشید تا پوست تنفس داشته باشد و دچار سوزش نشود.
   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px;\nfont-size:30px;"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>نحوه اصلاح موها   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>چند روز پس از لیزر ممکن است موهای سوخته روی پوست باقی بمانند — این طبیعی است.
از کندن موها با موم یا اپیلاتور پرهیز کنید و در صورت نیاز تنها با ژیلت اصلاح نمایید.
   <m-h2 v-bind='{...{},...{}}' :style='"border-radius:30px;\nfont-size:30px;"' class="text-center shadow m-4 p-4 my-5" >
                <template #default>توجه به واکنش‌های پوستی   </template>
                </m-h2><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>اگر دچار تاول، خارش شدید یا تغییر رنگ پوست شدید، سریعاً با مرکز لیزر یا پزشک مشورت کنید.
   <m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>نکته: مراقبت صحیح بعد از لیزر، تأثیر جلسات درمان را چند برابر کرده و از بروز عوارض پوستی جلوگیری می‌کند   </template>
                </m-h3></template>
                </m-h3></template>
                </m-h3></template>
                </m-h3></template>
                </m-h3></template>
                </m-h3></template>
                </m-h3></template>
                </m-h4></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="py-4 bg-secondary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-md-6" >
                <template #default>   <m-section-300 v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.clinicyas.ir\/storage\/assets\/Tizer Johar 9 1-1.mp4","autoplay":true,"muted":true,"loop":false,"poster":null,"muteButton":true,"playButton":true,"fullScreenButton":true},...{}}' :style='"border-radius: 15px;\nheight:400px;"' class="" >
                <template #full_screen>تمام صفحه   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #mute>صدا   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #p-1>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #play>پخش   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-section-300></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-md-6  my-auto px-4" >
                <template #default>   <m-heading-3 v-bind='{...{},...{}}' :style='""' class="text-dark" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-primary mt-4 col-12" >
                <template #default>مراقبت ها    </template>
                </m-h3></template>
                </m-heading-3><m-p v-bind='{...{},...{}}' :style='""' class="my-auto text-justify pt-3" >
                <template #default>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان    </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mSection300 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section300'; import mHeading3 from '@moeinmdn/miw-alpha-components/src/package/Heading/Heading3'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mH4,mH1,mH2,mH3,mSection300,mHeading3,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
